import { useKeycloak } from '@react-keycloak/web';
import { useCallback, useMemo } from 'react';

import {
  SearchByCategoryRequest,
  SearchCategory,
  SearchFrame,
  SearchRequest,
} from '../model/types';
import { PageResponseSearchHitResponse, Search } from './Search';

const DEFAULT_PAGE_SIZE = 25;

const useSearchService = () => {
  const { keycloak } = useKeycloak();
  const token = keycloak.token;

  const searchApiClient = useMemo(
    () => new Search({ headers: { Authorization: `Bearer ${token}` } }),
    [token],
  );

  const streamSearch = useCallback(
    (request: SearchRequest, onFrame: (frame: SearchFrame) => void, signal: AbortSignal) =>
      searchApiClient.search(request, { token, signal, onFrame }),
    [searchApiClient, token],
  );

  const searchByCategory = useCallback(
    async (
      query: string,
      category: SearchCategory,
      pageNumber: number,
      signal: AbortSignal | undefined,
      numberOfItems: number = DEFAULT_PAGE_SIZE,
    ): Promise<PageResponseSearchHitResponse> => {
      const request: SearchByCategoryRequest = { query, category, pageNumber, numberOfItems };
      const { data } = await searchApiClient.searchByCategory(request, { signal });
      return data;
    },
    [searchApiClient],
  );

  return { streamSearch, searchByCategory };
};

export default useSearchService;
